import { ref } from "vue";
import { useNotificationStore } from "@/store/notificationStore";
import { NOTIFICATION_TYPES } from "@/constants/notificationTypes";

class WebSocketService {
  constructor() {
    this.ws = null;
    this.isConnected = ref(false);
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.connectionTimeout = null;
  }

  async connect(url) {
    try {
      this.ws = new WebSocket(url);

      this.ws.onopen = async () => {
        console.log("WebSocket conectado");
        this.isConnected.value = true;
        this.reconnectAttempts = 0;
        // Intentar registrarse automáticamente si hay token
        await this.autoRegister();
      };

      this.ws.onclose = () => {
        console.log("WebSocket desconectado");
        this.isConnected.value = false;
        this.tryReconnect();
      };

      this.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === "connection_established") {
            this.isConnected.value = true;
            this.reconnectAttempts = 0;
          }
          this.handleMessage(data);
        } catch (error) {
          console.error("Error al procesar mensaje:", error);
        }
      };

      this.ws.onerror = (error) => {
        console.error("Error WebSocket:", error);
      };
    } catch (error) {
      console.error("Error al conectar WebSocket:", error);
    }
  }

  // Nuevo método para auto-registro
  async autoRegister() {
    const authToken = localStorage.getItem("authToken");
    if (authToken && this.isConnected.value) {
      try {
        await this.send({ type: "register", auth: authToken });
        console.log("Auto-registro exitoso");
      } catch (error) {
        console.error("Error en auto-registro:", error);
      }
    }
  }

  async tryReconnect() {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      console.log(`Intento de reconexión ${this.reconnectAttempts}...`);
      setTimeout(() => {
        this.connect(this.ws.url);
      }, 3000); // Espera 3 segundos antes de reconectar
    }
  }

  handleMessage(data) {
    console.log("Mensaje WebSocket recibido:", data);
    const notificationStore = useNotificationStore();

    switch (data.type) {
      case "system_alert":
        notificationStore.addNotification({
          title: data.title || "Alerta del Sistema",
          message: data.message,
          type: "system",
          data: data.details,
        });
        break;

      case "notification":
        notificationStore.addNotification({
          title: data.title,
          message: data.message,
          type: data.notificationType,
          data: data.payload,
        });
        break;

      case "payment_received":
        notificationStore.addNotification({
          type: NOTIFICATION_TYPES.PAYMENT,
          title: "Nuevo Pago Recibido",
          message: `Se ha registrado un pago por $${data.amount}`,
          data: data.paymentDetails,
        });
        break;
    }
  }

  send(message) {
    return new Promise((resolve, reject) => {
      if (this.ws && this.isConnected.value) {
        try {
          this.ws.send(JSON.stringify(message));
          resolve();
        } catch (error) {
          reject(error);
        }
      } else {
        reject(new Error("WebSocket no está conectado"));
      }
    });
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
    }
  }
}

export const wsService = new WebSocketService();
